import React from 'react';
import IndicatorList from '../../../features/indicatorList/IndicatorList';
import RestrictiveLayer from './components/RestrictiveLayer';
import SoilProfile from './components/SoilProfile';
import SoilsSummary from './components/SoilsSummary';

export default function SoilsTab() {
  return (
    <React.Fragment>
      <SoilProfile />
      <RestrictiveLayer />
      <IndicatorList indicatorType="Soil" indicatorCategory="Regular" />
      <IndicatorList indicatorType="Soil" indicatorCategory="Problem" />
      <SoilsSummary />
    </React.Fragment>
  )
}
